<template>
    <div class="newRetailAccount">
        <!-- 弹出日历控件 -->
        <van-popup
            v-model="showCalendar"
            position="bottom"
            :style="{ height: '50%' }"
        >
            <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                @confirm="confirmMonth"
                @cancel="showCalendar=false"
            ></van-datetime-picker>
        </van-popup>
        <section class="van-pull-refresh">
            <van-form validate-first>
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <div slot="title" class="title">
                            <i class="iconfont icondingdan"></i>基本信息
                        </div>
                        <van-field
                            label="编号"
                            :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                            input-align="right"
                            placeholder=""
                            v-model="formData.xxxxx"
                            readonly
                        ></van-field>
                        <van-field
                            label="合同名称"
                            :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                            input-align="right"
                            placeholder=""
                            v-model="formData.xxxxx"
                            readonly
                        ></van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                            label="供应商名称"
                            placeholder="请输入"
                            input-align="right"
                            v-model="formData.xxxx"
                            class="star"
                        >
                        </van-field>
                        <van-field
                            :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                            label="合同总价（万元）"
                            placeholder="请输入"
                            input-align="right"
                            v-model="formData.xxxx"
                            class="star"
                        >
                        </van-field>
                    </van-collapse-item>
                    <van-collapse-item name="2">
                        <div slot="title" class="title">
                            物料价格信息<van-icon @click.stop="addFun" class="add_icon" name="add"></van-icon>
                        </div>
                        <div class="info_box">
                            <div
                                class="list_item"
                                v-for="(item, index) in list"
                                :key="index"
                            >
                                <p class="title">
                                    <span>{{ item.name }}</span>
                                    <span>{{ item.type }}</span>
                                </p>
                                <div class="ps_box">
                                    <div class="list_item_card list_item_card2">
                                        <div>规格要求：</div>
                                        <div>
                                            <van-field
                                                v-model="item.type"
                                                is-link
                                                readonly
                                                name="picker"
                                                label="选择器"
                                                placeholder="点击选择"
                                                @click="showPopup('yq')"
                                            >
                                            </van-field>
                                        </div>
                                    </div>
                                    <div class="list_item_card">
                                        <div>送货地点：</div>
                                        <div>
                                            <van-field
                                                v-model="item.type"
                                                is-link
                                                readonly
                                                name="picker"
                                                label="选择器"
                                                placeholder="点击选择"
                                                @click="showPopup('yq')"
                                            >
                                            </van-field>
                                        </div>
                                    </div>
                                    <div class="list_item_card list_item_card2">
                                        <div>数量（个）：</div>
                                        <div>
                                            <van-field
                                                v-model="item.name"
                                                label="文本"
                                                placeholder="右对齐"
                                                label-align="right"
                                            >
                                            </van-field>
                                        </div>
                                    </div>
                                    <div class="list_item_card">
                                        <div>单价（元）：</div>
                                        <div>
                                            <van-field
                                                v-model="item.name"
                                                label="文本"
                                                placeholder="右对齐"
                                                label-align="right"
                                            >
                                            </van-field>
                                        </div>
                                    </div>
                                    <div class="list_item_card list_item_card2">
                                        <div>金额（元）：</div>
                                        <div>
                                            <van-field
                                                v-model="item.name"
                                                label="文本"
                                                placeholder="右对齐"
                                                label-align="right"
                                            >
                                            </van-field>
                                        </div>
                                    </div>
                                    <div class="list_item_card">
                                        <div>税率：</div>
                                        <div>
                                            <van-field
                                                v-model="item.name"
                                                label="文本"
                                                placeholder="右对齐"
                                                label-align="right"
                                            >
                                            </van-field>
                                        </div>
                                    </div>
                                    <div class="list_item_card list_item_card2">
                                        <div>运费单价（元）：</div>
                                        <div>
                                            <van-field
                                                v-model="item.name"
                                                label="文本"
                                                placeholder="右对齐"
                                                label-align="right"
                                            >
                                            </van-field>
                                        </div>
                                    </div>
                                    <div class="list_item_card">
                                        <div>运费税率：</div>
                                        <div>
                                            <van-field
                                                v-model="item.name"
                                                label="文本"
                                                placeholder="右对齐"
                                                label-align="right"
                                            >
                                            </van-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-collapse-item>
                </van-collapse>
                <van-action-sheet
                    v-model="showActionSheet"
                    :actions="columns"
                    @select="selectConfirm"
                    :style="{height: '30%'}"
                ></van-action-sheet>
                <!-- <select-org ref="selectOrg" @change="handleSelectOrg"></select-org> -->
            </van-form>
            <div class="btn-con">
                <div class="submit-btn" @click="handleSubmit">
                    提交
                </div>
                <div class="save-btn" @click="handleSave(null)">
                    保存
                </div>
            </div>
            <!-- 客户名称选择 -->
            <van-action-sheet
                v-model="showCustomerSelection"
                :actions="customerSelectionList"
                cancel-text="取消"
                close-on-click-action
                @select="handleSelect"
            ></van-action-sheet>
            <!-- 提交确认 -->
            <van-dialog
                v-model="confirmedByShow"
                title="提交确认"
                show-cancel-button
                @cancel="cancelSubmission"
                @confirm="confirmSubmission"
                class="submitPopUp"
            >
                <div class="submitPopUpContent">
                    <div class="icon">
                        <!-- <img src="@/assets/images/contractApproval/icon.png" alt=""> -->
                    </div>
                    <div class="info linkInfo">
                        <h4>
                            下一环节：
                            <span>
                                {{ submitObj.link }}
                            </span>
                        </h4>
                        <h4>
                            审批人：
                            <span>
                                {{ submitObj.obj }}
                            </span>
                        </h4>
                        <p>是否确认提交？</p>
                    </div>
                </div>
            </van-dialog>
        </section>
    </div>
</template>

<script>
import { Toast } from 'vant';
import util from '@/assets/js/utils';
// import selectOrg from './selectOrg';
export default {
    name: 'new-retail-account',
    // components: { selectOrg },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/retailAccountList') {
            this.$store.commit('noKeepAlive', 'new-retail-account');
        }
        next();
    },
    props: {},
    data() {
        return {
            list: [
                {
                    name: '1111111',
                    type: 1,
                },
                {
                    name: '1111111',
                    type: 2,
                },
                {
                    name: '1111111',
                    type: 2,
                },
                {
                    name: '1111111',
                    type: 2,
                },
                {
                    name: '1111111',
                    type: 2,
                },
                {
                    name: '1111111',
                    type: 1,
                },
                {
                    name: '1111111',
                    type: 1,
                },
                {
                    name: '1111111',
                    type: 1,
                },
            ],
            titleName: '新建',
            // 折叠面板-选中
            activeNames: ['1', '2', '3'],
            // 表单数据
            formData: {
                tax_rate_code: 0,
                tax_rate_value: '3%',
                client_uscc: '',
            },
            // 日历
            showCalendar: false,
            calendarType: '',
            currentDate: new Date(),
            // 字典下拉选项
            showActionSheet: false,
            originalColumns: [],
            columns: [],
            actionType: '',
            // 工程类型
            engineeringTypeColumns: [],
            engineeringTypeOriginal: [],
            // 客户性质
            clientTypeOriginal: [],
            clientTypeColumns: [],
            // 税率
            taxRateOriginal: [],
            taxRateColumns: [],
            // 支付方式
            payModeOriginal: [],
            payModeColumns: [],
            // 供货站点
            supplySiteOriginal: [],
            supplySiteColumns: [],
            // 销售区域
            saleAreaOriginal: [],
            saleAreaColumns: [],
            // 强度等级
            strengthGradeOriginal: [],
            strengthGradeColumns: [],
            // 浇筑部位
            castingPartsOriginal: [],
            castingPartsColumns: [],
            // 浇筑方式
            pouringWayOriginal: [],
            pouringWayColumns: [],
            // 流程信息
            businessInfo: {},
            // 操作 新增/修改
            type: '',
            businessCode: '',
            // 表单主键
            formKeyValue: '',
            // 当前流程环节数据
            approvalData: {},
            processData: {},
            CurrentBusinessProcess: {},
            // 是否是消息跳转审批
            isNews: false,
            // 当前合同id
            contractNumber: '',
            // 数字键盘
            showKeyboard: false,
            showPriceKeyboard: false,
            showCapacityKeyboard: false,
            showMoneyKeyboard: false,
            showFreightKeyboard: false,
            showDistanceKeyboard: false,
            keyboardValue: '',
            // 泵送单价是否可用
            volumePriceDisable: true,
            // 确认人员弹出层状态
            confirmedByShow: false,
            submitObj: {
                link: '',
                obj: '',
            },

            // 客户名称提示
            showCustomerSelection: false,
            // 客户集合
            customerSelectionList: [],
        };
    },
    watch: {},
    computed: {},
    created() {
        if (this.$route.params.title) {
            this.titleName = this.$route.params.title;
        }
    },
    // eslint-disable-next-line complexity
    activated() {
        this.getCategory('103', 'engineering_type');
        this.getCategory('002-xz0', 'client_type');
        this.getCategory('601-FK0', 'payment_mode');
        this.getCategory('105-ZT0', 'casting_parts');
        this.getCategory('302-JZ0', 'pouring_way');
        this.getStationList();
        this.getSaleAreaList();
        this.getStrengthGrade();
        this.getDictionary();
        this.formData = this.$route.params.formData || this.formData;
        this.type = this.type || this.$route.params.handleType;
        this.businessCode = this.businessCode || this.$route.params.businessCode;
        const actionType = this.$route.params.actionType;
        if (actionType === 'selectedProjectAddressCallBack') {
            // 选择工程地址完成
            const lnglatXY = this.$route.params.lnglatXY;
            const address = this.$route.params.address;
            this.formData.engineering_location = address;
            this.formData.x_coordinate_point = lnglatXY[0];
            this.formData.y_coordinate_point = lnglatXY[1];
        }
        // 新建
        if (this.type === 'new' && actionType !== 'uploadFile'
        && actionType !== 'selectedProjectAddressCallBack' && actionType !== 'selededAdditional') {
            this.formData.register_time = util.currentTimeFormat('yyyy-MM-dd HH:mm:ss');
            this.getBusinessInstance();
            this.formData.salesman_id = this.$takeTokenParameters('Uid');
            this.formData.salesman_name = this.$takeTokenParameters('Name');
            this.formData.salesman_phone = this.$takeTokenParameters('MobilePhone');
        }
        // 编辑
        if (this.type === 'modify' && actionType !== 'selectedProjectAddressCallBack'
        && actionType !== 'selededAdditional' && actionType !== 'uploadFile') {
            this.$toast.loading({ overlay: true, duration: 0 });
            this.contractNumber = this.contractNumber || this.$route.params.contractNumber || this.formData.contract_number;
            this.getRetailDetail(this.contractNumber);
        }
        // 复制新增
        if (this.type === 'copyNew' && actionType !== 'selectedProjectAddressCallBack'
        && actionType !== 'selededAdditional' && actionType !== 'uploadFile') {
            this.contractNumber = this.contractNumber || this.$route.params.contractNumber || this.formData.contract_number;
            this.getRetailDetailCopyNew(this.contractNumber);
            this.formData.register_time = util.currentTimeFormat('yyyy-MM-dd HH:mm:ss');
            this.getBusinessInstance();
        }
        this.$forceUpdate();
    },
    mounted() {},
    methods: {
        addFun() {},
        // 键盘输入
        keyBoardInput(value) {
            this.formData.pump_supplement_price = this.keyboardValue + value;
            this.$forceUpdate();
        },
        // 键盘删除
        keyBoardDel() {
            if (this.keyboardValue.length > 0) {
                this.keyboardValue = this.keyboardValue.substr(0, this.keyboardValue.length - 1);
            }
            this.formData.pump_supplement_price = this.keyboardValue;
            this.$forceUpdate();
        },
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'retailAccountList' });
            this.$router.go(-1);
        },
        // 定位界面
        toAddress() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'projectAddress',
                params: {
                    formData: this.formData,
                    from: 'newRetailAccount',
                    headTitle: '工程地址',
                },
            });
        },
        // 跳转到上传附件界面
        toUpload() {
            if (this.formKeyValue) {
                let BusinessInstanceId = '';
                if (this.type === 'new') {
                    BusinessInstanceId = this.businessInfo.BusinessInstanceId;
                } else {
                    BusinessInstanceId = this.formData.business_instance_id;
                }
                this.$router.isBack = 2;
                this.$router.push(
                    {
                        name: 'fileUpload',
                        params: {
                            formData: this.formData,
                            BusinessInstanceId: BusinessInstanceId,
                            type: this.type,
                            fromPath: 'newRetailAccount',
                            title: '附件上传',
                        },
                    });
            } else {
                this.$toast('请先保存表单！');
            }

        },
        // 保存
        async handleSave(callBackFn) {
            // 验证统一信心用代码
            const flag = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;
            if (!flag.test(this.formData.client_uscc)) {
                this.$toast('统一社会信用代码/身份证号输入错误');
                return;
            }
            const patrn = /^(-?\d+)(\.\d+)?$/;
            if (this.formData.price) {
                if (!patrn.test(Number(this.formData.price))) {
                    this.$toast('单价，非正规数字格式，请检查重新输入！');
                    return;
                }
            }
            if (this.formData.projected_capacity) {
                if (!patrn.test(Number(this.formData.projected_capacity ))) {
                    this.$toast('方量，非正规数字格式，请检查重新输入！');
                    return;
                }
            }
            if (this.formData.amount_money) {
                if (!patrn.test(Number(this.formData.amount_money))) {
                    this.$toast('金额，非正规数字格式，请检查重新输入！');
                    return;
                }
            }
            if (this.formData.haul_distance) {
                if (!patrn.test(Number(this.formData.haul_distance ))) {
                    this.$toast('运距，非正规数字格式，请检查重新输入！');
                    return;
                }
            }
            if (this.formData.freight) {
                if (!patrn.test(Number(this.formData.freight))) {
                    this.$toast('运费，非正规数字格式，请检查重新输入！');
                    return;
                }
            }
            const amount_money = this.formData.amount_money;
            const price = this.formData.price;
            const projected_capacity = this.formData.projected_capacity;
            let money = 0;
            if (price && projected_capacity) {
                money = Number(price) * Number(projected_capacity);
            }
            if (amount_money) {
                if (money > Number(amount_money) ) {
                    this.$toast('金额小于单价乘以方量，不能保存！');
                    return;
                }
            }
            this.$toast.loading({ overlay: true, duration: 0 });
            if (this.type === 'new' || this.type === 'copyNew') {
                this.formData.business_instance_id = this.businessInfo.BusinessInstanceId;
                const res = await this.getAutoCode();
                if (res) {
                    this.formData.contract_number = res.AutoCodeValue;
                    this.formData.auto_index = res.AutoIndex;
                    this.$forceUpdate();
                    this.$axios
                        .post('/interfaceApi/sale/contract_manager/add_retail', this.formData)
                        .then(res => {
                            if (res) {
                                this.getRetailDetail(this.formData.contract_number);
                                this.startBusinessInstance(callBackFn);
                                this.formKeyValue = res;
                                this.type = 'modify';
                                this.$toast('保存成功！');
                            }
                        }).catch(error => {
                            this.$toast.clear();
                            this.$toast({
                                type: 'html',
                                message: error.ErrorCode.Message,
                            });
                        });
                }
            } else {
                this.$axios
                    .put('/interfaceApi/sale/contract_manager/modify_retail', this.formData)
                    .then(res => {
                        if (res) {
                            this.$toast('修改成功！');
                            this.getCurrentProcess(callBackFn);
                        }
                    }).catch(error => {
                        this.$toast({
                            type: 'html',
                            message: error.ErrorCode.Message,
                        });
                    }).finally(() => {
                        this.$toast.clear();
                    });
            }
        },
        // 启动流程实例
        async startBusinessInstance(callBackFn) {
            this.$toast.loading({ overlay: true, duration: 0 });
            const data = {
                BusinessInstanceId: this.businessInfo.BusinessInstanceId,
                ConfigBusinessId: this.businessInfo.ConfigBusiness.BusinessId,
                BusinessCode: this.businessInfo.ConfigBusiness.BusinessCode,
                BusinessName: this.businessInfo.ConfigBusiness.BusinessName,
            };
            this.$axios
                .post('/interfaceApi/basicplatform/simpleflow/businessinstance', data)
                .then(res => {
                    if (res) {
                        this.saveFrom(callBackFn);
                    }
                }).catch(error => {
                    this.$toast({
                        type: 'html',
                        message: error.ErrorCode.Message,
                    });
                });
        },
        // 获取新的业务编码，目前只有新泰泰丰租户 使用
        async getBusinessCode(business_code) {
            const res = this.$axios.$get('/interfaceApi/basicplatform/simpleflow/second_develop/GetBusinessCode?business_code=' + business_code
                , { defEx: true });
            return res;
        },
        // 记录保存过的表单数据
        saveFrom(callBackFn) {
            const data = {
                BusinessInstanceId: this.businessInfo.BusinessInstanceId,
                BusinessPhaseId: '',
                FormId: this.businessInfo.BusinessFormList[0].FormId,
                FormName: this.businessInfo.BusinessFormList[0].FormName,
                FormUrl: this.businessInfo.BusinessFormList[0].FormUrl,
                FormKeyName: this.businessInfo.BusinessFormList[0].FormKeyName,
                FormKeyValue: this.formKeyValue,
            };
            this.$axios
                .post('/interfaceApi/basicplatform/simpleflow/businessinstance/businessform', data)
                .then(() => {
                    this.getCurrentProcess(callBackFn);
                }).catch(error => {
                    this.$toast({
                        type: 'html',
                        message: error.ErrorCode.Message,
                    });
                });
        },
        // 根据环节获取流程实例信息
        getProcessDatagetProcessData(callBackFn) {
            this.$axios
                .get('/interfaceApi/basicplatform/simpleflow/processes/'
                + this.approvalData.BusinessInstanceId + '/'
                + this.approvalData.BusinessProcessId)
                .then(res => {
                    // 流程数据
                    this.processData = res;
                    // 当前流程环节信息
                    this.CurrentBusinessProcess = res.CurrentBusinessProcess;
                    if (callBackFn) {
                        callBackFn();
                    }
                })
                .catch(error => {
                    this.$toast.clear();
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 提交
        handleSubmit() {
            if (JSON.stringify(this.CurrentBusinessProcess) === '{}') {
                this.handleSave(this.toSubmission);
            } else {
                this.toSubmission();
            }
        },
        // 跳转到提交界面
        async toSubmission() {
            this.$toast.clear();
            // 获取环节数据请求
            // eslint-disable-next-line max-len
            const linkData = await this.getLinkDataRequest(this.approvalData.BusinessInstanceId, this.CurrentBusinessProcess.CurrentBusinessProcessId);
            let childrenData;
            // 提交会签环节
            if (!linkData.SubmitPhaseModel && linkData.SubmitPhaseNodes) {
                childrenData = {
                    title: '会签环节',
                    type: 'countersign',
                    processData: this.processData,
                };
                // 判断环节提交模式和审批人类别，环节提交模式=1（默认环节），审批人类别=2（角色），打开选择人员弹出层
            } else if (
                linkData.PhaseSubmitMode === 1
                && linkData.SubmitPhaseModel
                && linkData.SubmitPhaseModel.ApproverType === 2
                && linkData.SubmitPhaseModel.IsAllowEditApprover
            ) {
                this.approverRoleId = linkData.SubmitPhaseModel.ApproverRoleId.split(',');
                this.approverRoleName = linkData.SubmitPhaseModel.ApproverRoleName.split(',');
                childrenData = {
                    title: '普通提交',
                    type: 'role',
                    approverRoleId: this.approverRoleId,
                    approverRoleName: this.approverRoleName,
                    processData: this.processData,
                };

                // 判断环节提交模式和审批人类别，环节提交模式=2或者=3（指定环节、自由环节）
            } else if ([2, 3].indexOf(linkData.PhaseSubmitMode) > -1) {
                childrenData = {
                    title: '自由提交',
                    type: 'link',
                    processData: this.processData,
                };
            } else {
                this.submitObj.link = linkData.SubmitPhaseModel.BusinessPhaseName;
                this.submitObj.obj = linkData.SubmitPhaseModel.ApproverName;
                this.confirmedByShow = true;
            }

            if (childrenData) {
                this.$router.isBack = 2;
                this.$toast.clear();
                this.$router.push({
                    name: 'submission',
                    params: {
                        data: childrenData,
                        isNews: this.isNews,
                        backPathName: 'retailAccountList',
                    },
                });
            }
        },

        // 取消提交
        cancelSubmission() {
            this.$toast('已取消！');
        },

        // 确认提交
        confirmSubmission() {
            const data = {
                BusinessInstanceId: this.approvalData.BusinessInstanceId,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 10,
            };
            this.submitAPI(data, '提交成功！', '/interfaceApi/basicplatform/simpleflow/processes');
        },

        // 流程提交请求
        submitAPI(data, message, url) {
            this.isloading = true;
            this.$axios
                .post(url, data)
                .then(() => {
                    this.$toast.success(message);
                    this.isReadOnly = true;
                    this.isloading = false;
                    if (this.isNews !== true) {
                        this.$router.isBack = 1;
                        this.$router.replace({
                            name: 'retailAccount',
                            params: {
                                isRefresh: true,
                            },
                        });
                        this.$router.go(-1);
                    }
                })
                .catch(error => {
                    this.isloading = false;
                    this.$toast({
                        type: 'html',
                        message: error.ErrorCode.Message,
                    });
                });
        },

        // 获取流程模板信息
        async getBusinessInstance() {
            const res = await this.$axios.$get('/interfaceApi/basicplatform/simpleflow/businessinstance/templateinfo/' + this.businessCode);
            if (res) {
                this.businessInfo = res;
            }
        },
        // 获取当前流程环节
        getCurrentProcess(callBackFn) {
            this.$axios.get('/interfaceApi/basicplatform/simpleflow/processes/transaction_model/' + this.formData.business_instance_id)
                .then(res => {
                    if (res) {
                        this.approvalData = res;
                        this.getProcessData(callBackFn);
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 根据环节获取流程实例信息
        async getProcessData(callBackFn) {
            const res = await this.getProcessDataRequest();
            // 流程数据
            this.processData = res;
            // 当前流程环节信息
            this.CurrentBusinessProcess = res.CurrentBusinessProcess;
            if (callBackFn) {
                callBackFn();
            }
        },
        // 初始化订单编号
        getAutoCode() {
            return this.$axios.$get('/interfaceApi/basicplatform/autocode/runtime?code=lsh_contract_code');
        },
        // 获取零售业务台账明细
        getRetailDetail(contractNumber) {
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_retail_detail/' + contractNumber)
                .then(res => {
                    if (res) {
                        // res.price = res.price + '';
                        // res.projected_capacity = res.projected_capacity + '';
                        // res.amount_money = res.amount_money + '';
                        // res.haul_distance = res.haul_distance + '';
                        // res.freight = res.freight + '';
                        this.formData = res;
                        this.$toast.clear();
                        this.formKeyValue = res.ciid;
                        const value = res.pouring_way_name;
                        if (value === '汽车泵' || value === '车载泵' || value === '固定泵') {
                            this.volumePriceDisable = false;
                        } else {
                            this.pump_supplement_price = 0;
                            this.volumePriceDisable = true;
                        }
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取零售业务台账明细
        getRetailDetailCopyNew(contractNumber) {
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_retail_detail/' + contractNumber)
                .then(res => {
                    if (res) {
                        this.formData.engineering_name = res.engineering_name;
                        this.formData.engineering_type = res.engineering_type;
                        this.formData.engineering_type_name = res.engineering_type_name;
                        this.formData.section = res.section;
                        this.formData.engineering_location = res.engineering_location;
                        this.formData.x_coordinate_point = res.x_coordinate_point;
                        this.formData.y_coordinate_point = res.y_coordinate_point;
                        this.formData.client_name = res.client_name;
                        this.formData.client_type = res.client_type;
                        this.formData.client_type_name = res.client_type_name;
                        this.formData.client_uscc = res.client_uscc;
                        this.formData.client_contact_id = res.client_contact_id;
                        this.formData.client_contact_name = res.client_contact_name;
                        this.formData.client_contact_phone = res.client_contact_phone;
                        this.formData.salesman_id = res.salesman_id;
                        this.formData.salesman_name = res.salesman_name;
                        this.formData.salesman_phone = res.salesman_phone;
                        this.formData.supply_site = res.supply_site;
                        this.formData.supply_site_name = res.supply_site_name;
                        this.formData.area_id = res.area_id;
                        this.formData.area_name = res.area_name;
                        this.formData.haul_distance = res.haul_distance + '';
                        this.$toast.clear();
                        const value = res.pouring_way_name;
                        if (value === '汽车泵' || value === '车载泵' || value === '固定泵') {
                            this.volumePriceDisable = false;
                        } else {
                            this.pump_supplement_price = 0;
                            this.volumePriceDisable = true;
                        }
                        this.$forceUpdate();
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 展示日历
        handleShowCalendar(type) {
            this.calendarType = type;
            this.showCalendar = true;
        },
        // 登记时间-确认选择
        confirmMonth(value) {
            if (this.calendarType === 'register_time') {
                this.formData.register_time = this.formatDate(value);
            } else {
                this.formData.used_materialtime = this.formatDate(value);
            }
            this.showCalendar = false;
        },
        // 返回的时间格式化
        formatDate(date) {
            let month = date.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }
            let day = date.getDate();
            if (day < 10) {
                day = '0' + day;
            }
            let Hours = date.getHours();
            if (Hours < 10) {
                Hours = '0' + Hours;
            }
            let Minutes = date.getMinutes();
            if (Minutes < 10) {
                Minutes = '0' + Minutes;
            }
            let Seconds = date.getSeconds();
            if (Seconds < 10) {
                Seconds = '0' + Seconds;
            }
            return `${date.getFullYear()}-${month}-${day} ${Hours}:${Minutes}:${Seconds}`;
        },
        // 展示下拉选择
        showPopup(type) {
            this.actionType = type;
            switch (type) {
                // 工程类型
                case 'engineering_type':
                    if (this.engineeringTypeColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.engineeringTypeColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 客户类型
                case 'client_type':
                    if (this.clientTypeColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.clientTypeColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 税率
                case 'tax_rate':
                    if (this.taxRateColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.taxRateColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 支付方式
                case 'payment_mode':
                    if (this.payModeColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.payModeColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 供货站点
                case 'supply_site':
                    if (this.supplySiteColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.supplySiteColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 销售区域
                case 'area_name':
                    if (this.saleAreaColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.saleAreaColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 强度等级
                case 'strength_grade':
                    if (this.strengthGradeColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.strengthGradeColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 浇筑部位
                case 'casting_parts':
                    if (this.castingPartsColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.castingPartsColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 浇筑方式
                case 'pouring_way':
                    if (this.pouringWayColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.pouringWayColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                // 浇筑方式
                case 'yq':
                    if (this.pouringWayColumns.length > 0) {
                        this.showActionSheet = true;
                        this.columns = this.pouringWayColumns;
                    } else {
                        this.showActionSheet = false;
                        Toast('暂无数据');
                    }
                    break;
                default:
                    // 默认代码块;
            }
        },
        // 下拉确认选择
        selectConfirm(data) {
            let obj = [];
            switch (this.actionType) {
                // 工程类型
                case 'engineering_type':
                    this.formData.engineering_type_name = data.name;
                    obj = this.engineeringTypeOriginal.filter(item => item.name === data.name);
                    this.formData.engineering_type = obj[0].code;
                    this.showActionSheet = false;
                    break;
                // 客户类型
                case 'client_type':
                    this.formData.client_type_name = data.name;
                    obj = this.clientTypeOriginal.filter(item => item.name === data.name);
                    this.formData.client_type = obj[0].code;
                    this.showActionSheet = false;
                    break;
                case 'tax_rate':
                    this.formData.tax_rate_value = data.name;
                    obj = this.taxRateOriginal.filter(item => item.dic_name === data.name);
                    this.formData.tax_rate_code = obj[0].dic_code;
                    this.showActionSheet = false;
                    break;
                // 支付方式
                case 'payment_mode':
                    this.formData.payment_mode_name = data.name;
                    obj = this.payModeOriginal.filter(item => item.name === data.name);
                    this.formData.payment_mode = obj[0].code;
                    this.showActionSheet = false;
                    break;
                // 供货站点
                case 'supply_site':
                    this.formData.supply_site_name = data.name;
                    obj = this.supplySiteOriginal.filter(item => item.name === data.name);
                    this.formData.supply_site = obj[0].station_id;
                    this.showActionSheet = false;
                    break;
                // 销售区域
                case 'area_name':
                    this.formData.area_name = data.name;
                    obj = this.saleAreaOriginal.filter(item => item.name === data.name);
                    this.formData.area_id = obj[0].id;
                    this.showActionSheet = false;
                    break;
                // 强度等级
                case 'strength_grade':
                    this.formData.strength_grade_name = data.name;
                    obj = this.strengthGradeOriginal.filter(item => item.name === data.name);
                    this.formData.strength_grade = obj[0].code;
                    this.showActionSheet = false;
                    break;
                // 浇筑部位
                case 'casting_parts':
                    this.formData.casting_parts_name = data.name;
                    obj = this.castingPartsOriginal.filter(item => item.name === data.name);
                    this.formData.casting_parts = obj[0].code;
                    this.showActionSheet = false;
                    break;
                // 浇筑方式
                case 'pouring_way':
                    this.formData.pouring_way_name = data.name;
                    obj = this.pouringWayOriginal.filter(item => item.name === data.name);
                    this.formData.pouring_way = obj[0].code;
                    this.showActionSheet = false;
                    if (data.name === '汽车泵' || data.name === '车载泵' || data.name === '固定泵') {
                        this.volumePriceDisable = false;
                    } else {
                        this.volumePriceDisable = true;
                        this.pump_supplement_price = 0;
                    }
                    break;
                default:
                    // 默认代码块;
            }

        },
        // 获取下拉框数据列表
        getCategory(parentCode, type) {
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=' + parentCode)
                .then(res => {
                    if (res) {
                        if (type === 'engineering_type') { // 工程类型
                            this.engineeringTypeOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.engineeringTypeColumns = arr;
                        } else if (type === 'client_type') {
                            this.clientTypeOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.clientTypeColumns = arr;
                        } else if (type === 'payment_mode') {
                            this.payModeOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.payModeColumns = arr;
                        } else if (type === 'casting_parts') {
                            this.castingPartsOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.castingPartsColumns = arr;
                        } else if (type === 'pouring_way') {
                            this.pouringWayOriginal = res;
                            const arr = [];
                            res.map(item => {
                                arr.push({ name: item.name });
                            });
                            this.pouringWayColumns = arr;
                        }
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取供货站点下拉list
        getStationList() {
            const queryStr = '?companyId=' + this.$takeTokenParameters('CompanyId') + '&branchId=' + this.$takeTokenParameters('BranchId');
            this.$axios
                .get('/interfaceApi/baseinfo/stationmanger/get_station_list' + queryStr)
                .then(res => {
                    if (res) {
                        this.supplySiteOriginal = res;
                        const arr = [];
                        res.map(item => {
                            if (item.is_enabled) {
                                arr.push({ name: item.name });
                            }
                        });
                        this.supplySiteColumns = arr;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取销售区域下拉list
        getSaleAreaList() {
            this.$axios
                .get('/interfaceApi/sale/price_config/get_area_list')
                .then(res => {
                    if (res) {
                        this.saleAreaOriginal = res;
                        const arr = [];
                        res.map(item => {
                            arr.push({ name: item.name });
                        });
                        this.saleAreaColumns = arr;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取强度等级
        getStrengthGrade() {
            this.strengthGradeOriginal = [];
            this.strengthGradeColumns = [];
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist_recursion?parent_code=004')
                .then(res => {
                    if (res) {
                        for (let i = res.length - 1; i >= 0; i--) {
                            if (res[i].level === 3) {
                                this.strengthGradeColumns.unshift({ name: res[i].name });
                                this.strengthGradeOriginal.unshift(res[i]);
                            }
                        }
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist_recursion?parent_code=005')
                .then(res => {
                    if (res) {
                        res.map(item => {
                            if (item.level === 3) {
                                this.strengthGradeColumns.push(item);
                                this.strengthGradeOriginal.push(item);
                            }
                        });
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取字典列表
        async getDictionary() {
            const taxRateList = await this.getTaxRateList();
            if (taxRateList.length > 0) {
                this.taxRateOriginal = taxRateList;
                const taxRateColumns = [];
                taxRateList.forEach(item => {
                    taxRateColumns.push({ name: item.dic_name });
                });
                this.taxRateColumns = taxRateColumns;
                if (!this.formData.tax_rate_code) {
                    const hasCheck = taxRateList.find(item => item.is_check);
                    this.formData.tax_rate_code = hasCheck.dic_code;
                    this.formData.tax_rate_value = hasCheck.dic_name;
                }
            }
        },
        // 选择附加型号
        showRequireList() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'selectAdditionalModel', params: { formData: this.formData, handleType: this.type } });
        },
        // 选择业务员
        selectSalesMan() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'selectSalesman', params: { formData: this.formData, handleType: this.type } });
        },
        inputFocusout() {
            this.timer = setTimeout(() => {
                window.scrollTo(0, 0);
                // 间隔设为10，减少页面失去焦点定时器的突兀感，
            }, 10);
        },
        showSelectOrg() {
            this.$refs.selectOrg.show = true;
        },
        // 选择供方单位
        handleSelectOrg(item) {
            this.$set(this.formData, 'org_code', item.org_code);
            this.$set(this.formData, 'org_name', item.org_name);
        },

        // 客户名称建议列表数据
        async customerNameInput() {
            this.customerSelectionList = await this.getClients(this.formData.client_name);
            this.showCustomerSelection = true;
        },

        // 客户选择
        handleSelect(item) {
            this.formData.client_type = item.nature;
            this.formData.client_type_name = item.nature_name;
            this.formData.client_id = item.id;
            this.formData.client_name = item.name;
            this.formData.client_uscc = item.license_code;
            this.formData.client_contact_name = item.client_contact_name;
            this.formData.client_contact_phone = item.client_contact_phone;
        },

        // 拉取客户信息列表
        getClients(Keywords) {
            return this.$axios.$get(`/interfaceApi/sale/client_manager/get_clients?Keywords=${Keywords}`, { defEx: true });
        },
        // 获取环节数据请求
        getLinkDataRequest(businessInstanceId, businessPhaseId) {
            const path = `/interfaceApi/basicplatform/simpleflow/processes/getcurrentbusinessprocess/${businessInstanceId}/${businessPhaseId}`;
            return this.$axios.$get(path, { defEx: true });
        },
        // 根据环节获取流程实例信息请求
        getProcessDataRequest() {
            // eslint-disable-next-line max-len
            return this.$axios.$get(`/interfaceApi/basicplatform/simpleflow/processes/${this.approvalData.BusinessInstanceId}/${this.approvalData.BusinessProcessId}`, { defEx: true, token: this.newsToken });
        },
        // 获取税率列表
        getTaxRateList() {
            return this.$axios.$get('/interfaceApi/sale/contract_price/get_tax_rate', { defEx: true });
        },
    },

};
</script>
<style lang="stylus">
.newRetailAccount
    height 100%
    position relative
    section
        height calc(100% - 45rpx)
        overflow scroll
        -webkit-overflow-scrolling touch
        padding-bottom 40rpx
        position relative
        .van-collapse
            padding: 15rpx;
            background: #F0F0F0;
        .van-collapse-item
            margin-bottom: 15rpx;
        .slump
            display inline-block
            width 35rpx
            border none
            &.slump1
                text-align right
                display inline-block
                width 30%
                border none
        .van-icon
            .van-icon__image
                width 16rpx
                height 16rpx
                margin-top 3rpx
                margin-right 5rpx
        .van-collapse
            &:after
                display none
        .van-cell__title
            width 100rpx
            font-size 15rpx
            line-height 24rpx
            color #061F3E
            .iconfont
                font-size 18rpx
                margin-right 5rpx
        .van-collapse-item__content
            .van-cell__title
                font-size 15rpx
        .van-button
            vertical-align top
        .title
            font-size 17rpx
            color #E93543
            .add_icon
                margin-left 15rpx
        .info_box
            width 100%
            height calc(100% - 45rpx)
            overflow-y scroll
            padding 15px
            .van-cell__right-icon
                color #666
            .list_item
                background #fff
                margin-bottom 15rpx
                box-shadow: 0px 0px 3px 0px #b5b5b5;
                border-radius: 8rpx;
                position relative
                .title
                    width 100%
                    height 50rpx
                    background #F8F8F8
                    margin-bottom 0 !important
                    display flex
                    align-items center
                    padding 0 20rpx
                    box-shadow: 0px 2px 3px -2px #b5b5b5;
                    font-size 16rpx
                    font-weight: 550;
                    position relative
                    border-radius: 8rpx 8rpx 0 0;
                    display: flex;
                    justify-content: space-between;
                    span
                        color: #000 !important
                    .btn
                        position absolute
                        top 0
                        right 0
                        color #fff !important
                        font-size 13rpx !important
                        background: #f86565;
                        padding 2rpx 5rpx
                        border-radius: 0 8rpx
                        font-weight: 500 !important;
                        &.btn_ok
                            background #ccc !important
                .ps_box
                    padding 15px
                    display: flex
                    flex-wrap: wrap;
                    .list_item_card
                        width calc(50% - 15rpx)
                        margin-bottom 15rpx
                        input
                            width 100%
                            // height 20rpx
                        .van-cell__title
                            display none
                        .van-cell
                            border: 1px solid #ADC7E0;
                            background #FAFBFE
                            border-radius 6px
                    .list_item_card2
                        margin-right 30rpx
                p
                    margin-bottom 10px
                    color #333
                    span
                        color #777
                    &last-child
                        margin-bottom 0
                >>>.van-button--plain.van-button--danger
                    background: #fcebec;
                    width: 60rpx;
                    height 25rpx
                    position absolute
                    bottom 25rpx
                    right 10rpx
        .van-collapse-item__content
            padding 0
        .van-field__control,
        .van-cell__value
            // color #979EA7
            &::placeholder
                color #D7D7D7 !important
        .textarea
            position relative
            &:before
                position absolute
                top 20rpx
                left 26rpx
            textarea
                text-indent 30rpx
                &.van-field__control
                    border 1px solid #D7D7D7
                    border-radius 4px
                    padding 10rpx
                    height 100rpx !important
                    &::-webkit-input-placeholder
                        font-size 16rpx
        .textarea-parts
            width 100%
            .van-field__control
                border 1px solid #D7D7D7
                border-radius 4px
                padding 6rpx 10rpx
                height 60rpx !important
                font-size 14rpx
                &::-webkit-input-placeholder
                    font-size 16rpx
        .custom-field
            .van-field__control
                justify-content flex-end
                input
                    border none
                    text-align right
                    margin-right 5rpx
                    &::webkit-input-placeholder
                        color #ddd
        .trans-types
            .van-field__control--custom
                display block
                .van-radio-group
                    margin-bottom 10rpx
            .custom-row
                margin-bottom 10rpx
                input
                    width 50rpx
                    border 0
                    border-bottom 1px solid #ccc
                    margin 0 10rpx
                    height 20rpx
                    text-align center
        .star
            .van-cell__title
                &:after
                    content '*'
                    color #E60000
    .submitPopUp
        .van-dialog__header
            padding-top 0
            line-height 50rpx
        .van-dialog__content
            padding 15rpx 0
            border-top 2px solid #F0F0F0
            text-align center
            .icon, .info
                display inline-block
                vertical-align top
            .icon
                width 94rpx
                height 84rpx
                img
                    height 100%
            .info
                text-align left
                margin-top 10rpx
                h4
                    line-height 20rpx
                    font-size 14rpx
                    color #666666
                    margin-bottom 20rpx
                    span
                        font-size 18rpx
                        color #3495FB
                p
                    font-size 14rpx
                    color #979EA7
                &.linkInfo
                    margin-top 5rpx
                    h4
                        margin-bottom 10rpx
    .customerSelection
        background #fff
        box-shadow 0 8px 12px rgb(100 101 102 / 12%)
        position fixed
        width 100%
        top 100px
        left 0
    .btn-con
        display flex
        position fixed
        width 100%
        height 59rpx
        bottom 0
        z-index 0
        background #fff
        padding 10rpx 25rpx
        div
            flex 1
            height 39rpx
            text-align center
            line-height 39rpx
            cursor pointer
        .submit-btn
            background #fcebec
            border 1px solid #f9cdcf
            color #ea4b49
            margin-right 18rpx
        .save-btn
            color #fff
            background: linear-gradient(to right, #EB6348, #e93543);
    .van-collapse-item > div:first-of-type
        background linear-gradient(to bottom, #FFF4F2, #fff)
        .van-cell__right-icon
            color #e93543
</style>
